import { isTodayOrFuture } from '@/utils/datetime/checks'
import { match } from 'ts-pattern'
import { z } from 'zod'

export const pollFormSchema = (maxCap: number) =>
	z.object({
		question: z.string().min(4, 'Question must be at least 10 characters long'),
		answers: z.array(z.object({ value: z.string() })).min(1, 'At least one answer is required'),
		votingCap: z
			.number()
			.int()
			.min(1, 'Poll cap cannot be less than 1')
			.max(maxCap, `Poll cap exceeds the max supply : ${maxCap.toLocaleString('en-US')}`),
		startTime: z.date(),
		endTime: z.date()
	})

export const startTimeRefinement = (data: { startTime: Date }, ctx: z.RefinementCtx) => {
	const now = new Date()

	const xMinutesLater = new Date(
		now.getTime() +
			match(import.meta.env.VITE_ENV)
				.with('integration', () => 0.5)
				.with('staging', () => 0.5)
				.with('spicy', () => 10)
				.otherwise(() => 10) *
				60000
	)

	if (!isTodayOrFuture(data.startTime)) {
		ctx.addIssue({
			code: 'custom',
			path: ['startTime'],
			message: 'Start date must be today or in the future'
		})
	}

	// Ensure startTime is at least 10 minutes ahead if today
	if (data.startTime < xMinutesLater) {
		ctx.addIssue({
			code: 'custom',
			path: ['startTime'],
			message: `Start time must be at least ${xMinutesLater} from now`
		})
	}
}

export const endTimeRefinement = (data: { startTime: Date; endTime: Date }, ctx: z.RefinementCtx) => {
	// Ensure endDate is after startDate
	if (data.endTime <= data.startTime) {
		ctx.addIssue({
			code: 'custom',
			path: ['endDate'],
			message: 'End date must be after the start date'
		})
	}

	// Ensure endTime is after startTime only if startDate is today
	if (data.endTime <= data.startTime) {
		ctx.addIssue({
			code: 'custom',
			path: ['endTime'],
			message: 'End time must be after start time'
		})
	}
}
export type PollFormSchema = z.infer<ReturnType<typeof pollFormSchema>>
